(() => {
  const hop = document.querySelector('.hop');
  if (hop?.dataset.preview === 'true') return;
  const config = window.u360 || (hop ? { root: hop.dataset.root, currency: hop.dataset.currency } : {});
  const root = `${config.root || '/'}${String(config.root || '/').endsWith('/') ? '' : '/'}`;
  const cartDialog = document.querySelector('[data-u360-cart]');
  const cartBody = document.querySelector('[data-u360-cart-body]');
  const cartStatus = document.querySelector('[data-u360-cart-status][aria-live]');
  const productStatus = document.querySelector('[data-error-message]');
  const productForm = document.querySelector('[data-u360-product-form]');
  const variantImages = document.querySelectorAll('[data-u360-variant-image]');
  const stickyForm = document.querySelector('[data-u360-sticky-add]')?.closest('[class~="group/sticky"]');
  const navigation = document.querySelector('#u360-mobile-navigation');
  const navigationToggle = document.querySelector('[data-u360-navigation-toggle]');
  let cartVersion = 0, mutating = false;

  if (navigation && navigationToggle) {
    new MutationObserver(() => {
      navigationToggle.setAttribute('aria-expanded', navigation.classList.contains('active'));
    }).observe(navigation, { attributes: true, attributeFilter: ['class'] });
  }

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const money = (cents) => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: config.currency || 'USD'
  }).format(cents / 100);

  async function request(path, options = {}) {
    const response = await fetch(`${root}${path}`, {
      credentials: 'same-origin',
      ...options,
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  }

  function updateBadge(cart) {
    document.querySelectorAll('[data-u360-cart-count]').forEach((badge) => {
      badge.textContent = cart.item_count || '';
      if (hop) badge.hidden = !cart.item_count;
      badge.classList.toggle('has-items', (cart.item_count || 0) > 0);
      badge.setAttribute('aria-label', `${cart.item_count} items in your cart`);
    });
  }

  function renderItem(item, line) {
    const row = element('article', 'local-cart-item');
    if (item.image) {
      const image = element('img');
      image.src = item.image;
      image.alt = '';
      row.append(image);
    }

    const details = element('div');
    details.append(element('h3', '', item.product_title));
    if (item.variant_title && item.variant_title !== 'Default Title') {
      details.append(element('p', '', item.variant_title));
    }
    details.append(element('p', '', money(item.final_line_price)));

    const quantity = element('div', 'local-quantity');
    const decrease = element('button', '', '−');
    decrease.type = 'button';
    decrease.dataset.u360CartAction = 'decrease';
    decrease.dataset.line = line;
    decrease.dataset.quantity = item.quantity;
    decrease.setAttribute('aria-label', `Decrease ${item.product_title} quantity`);
    const output = element('output', '', item.quantity);
    const increase = element('button', '', '+');
    increase.type = 'button';
    increase.dataset.u360CartAction = 'increase';
    increase.dataset.line = line;
    increase.dataset.quantity = item.quantity;
    increase.setAttribute('aria-label', `Increase ${item.product_title} quantity`);
    quantity.append(decrease, output, increase);

    const remove = element('button', 'local-remove', 'Remove');
    remove.type = 'button';
    remove.dataset.u360CartAction = 'remove';
    remove.dataset.line = line;
    remove.setAttribute('aria-label', `Remove ${item.product_title} from cart`);
    details.append(quantity, remove);
    row.append(details);
    return row;
  }

  function render(cart) {
    updateBadge(cart);
    if (!cartBody) return cart;
    cartBody.replaceChildren();
    if (!cart.items.length) {
      cartBody.append(element('p', '', 'Your cart is empty.'));
      return cart;
    }

    cart.items.forEach((item, index) => cartBody.append(renderItem(item, index + 1)));
    const total = element('div', 'local-cart-total');
    total.append(element('span', '', 'Subtotal'), element('strong', '', money(cart.items_subtotal_price)));
    const checkout = element('button', 'local-checkout', 'Checkout');
    checkout.type = 'button';
    checkout.dataset.u360Checkout = '';
    cartBody.append(total, checkout, element('p', 'local-cart-note', 'Free standard delivery · Taxes calculated at checkout.'));
    return cart;
  }

  async function refresh() {
    const version = ++cartVersion;
    const cart = await request('cart.js');
    return version === cartVersion ? render(cart) : cart;
  }

  async function add(variantId, quantity = 1) {
    await request('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
    return refresh();
  }

  async function change(line, quantity) {
    const version = ++cartVersion;
    const cart = await request('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    return version === cartVersion ? render(cart) : cart;
  }

  const report = (message) => {
    if (cartStatus) cartStatus.textContent = message;
    if (productStatus) productStatus.textContent = message;
  };

  async function mutate(button, operation) {
    if (mutating) return;
    mutating = true;
    const controls = [...document.querySelectorAll('[data-u360-add], [data-u360-cart-action], [data-u360-checkout]')].map(control => [control, control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    report('');
    try {
      const cart = await operation();
      if (cartDialog && !cartDialog.open) cartDialog.showModal();
      return cart;
    } catch (error) {
      report(error.message || 'Something went wrong. Please try again.');
    } finally {
      mutating = false;
      controls.forEach(([control, disabled]) => { control.disabled = control.dataset.unavailable === undefined ? disabled : control.dataset.unavailable === 'true'; });
    }
  }

  productForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const button = productForm.querySelector('[data-u360-add]');
    const variant = productForm.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
    const quantity = productForm.querySelector('input[name="quantity"]');
    if (!button || !variant) return report('This product is currently unavailable.');
    mutate(button, () => add(variant.value, quantity?.value || 1));
  });

  productForm?.addEventListener('change', (event) => {
    const variant = event.target.closest('input[name="id"][data-u360-image-url]');
    if (!variant) return;
    variantImages.forEach((image) => {
      image.src = variant.dataset.u360ImageUrl;
      image.alt = variant.dataset.u360ImageAlt;
    });
  });

  if (productForm && stickyForm) {
    const mobile = window.matchMedia('(max-width: 1023px)');
    let currentEntry;
    const updateSticky = () => {
      if (!currentEntry) return;
      stickyForm.classList.toggle(
        'active',
        mobile.matches ? currentEntry.boundingClientRect.bottom < 0 : !currentEntry.isIntersecting
      );
    };
    new IntersectionObserver(([entry]) => {
      currentEntry = entry;
      updateSticky();
    }).observe(productForm);
    mobile.addEventListener('change', updateSticky);
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.matches('[data-u360-cart-open]')) cartDialog?.showModal();
    if (target.matches('[data-u360-cart-close]')) cartDialog?.close();
    if (target.matches('[data-u360-sticky-add]')) productForm?.requestSubmit();
    if (target.matches('[data-u360-checkout]')) window.location.assign(`${root}checkout`);

    const action = target.dataset.u360CartAction;
    if (!action) return;
    const current = Number(target.dataset.quantity || 0);
    const next = action === 'increase' ? current + 1 : action === 'decrease' ? Math.max(0, current - 1) : 0;
    mutate(target, () => change(target.dataset.line, next));
  });

  cartDialog?.addEventListener('click', (event) => {
    if (event.target === cartDialog) cartDialog.close();
  });

  window.U360Cart = { refresh, add, change, render, get busy() { return mutating; } };
  refresh().catch((error) => report(error.message || 'Unable to load your cart.'));
})();
